import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HiMenuAlt4 } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";
import './index.css';

export default function Menu({ setAudioPlayerOn, setPlayList }) {
    const [openMenu, setOpenMenu] = useState(false);
    function toggleMenu() {
        setOpenMenu(!openMenu);
    };
    function openAudioPlayer(playList) {
        const currentPlayer = localStorage.getItem('player');
        const currentPlaylist = localStorage.getItem('playlist');

        // Solo cambia si no está abierto o si se cambió la playlist
        if (!currentPlayer || currentPlaylist !== playList) {
            toggleMenu(); // Cierra menú

            // Actualiza la playlist y abre el reproductor
            setPlayList(playList);
            setAudioPlayerOn(true); // <- CAMBIAR A TRUE

            localStorage.setItem('player', true);
            localStorage.setItem('playlist', playList);
        }
    };
    return (
        <header className="menu-container">
            <div className="title-page">
                <Link to="/inicio/">
                    <img src="/assets/ipfb-title.png" className="img-title" />
                </Link>
                <p className="description-title">Iglesia Presbiteriana Fundamentalista Bíblica</p>
            </div>
            <aside className="icons-menu-control">
                <HiMenuAlt4 style={{ display: openMenu ? 'none' : 'block' }} className="icon-control" onClick={toggleMenu} />
                <IoMdClose style={{ display: openMenu ? 'block' : 'none' }} className="icon-control" onClick={toggleMenu} />
            </aside>
            <nav className={`nav-menu ${openMenu ? 'translate-menu-x-100' : 'translate-menu-x-0'}`}>
                <ul className="nav-link-list">
                    <li><Link className="link-nav-menu" to="/inicio/" onClick={toggleMenu}>Inicio</Link></li>
                    <li><Link className="link-nav-menu" to="/en-que-creemos/" onClick={toggleMenu}>¿En qué creemos?</Link></li>
                    <li><Link className="link-nav-menu" to="/compendio-historico/" onClick={toggleMenu}>Compendio histórico</Link></li>
                    <li><Link className="link-nav-menu" to="/documentos/" onClick={toggleMenu}>Documentos</Link></li>
                    <li><Link className="link-nav-menu" to="/iglesias/" onClick={toggleMenu}>Listado de Iglesias</Link></li>
                    <li><Link className="link-nav-menu" to="/noticias/" onClick={toggleMenu}>Noticias</Link></li>
                    <li><Link className="link-nav-menu" to="/equipo-pastoral/" onClick={toggleMenu}>Equipo Pastoral</Link></li>
                    <li><span className="link-nav-menu" onClick={() => openAudioPlayer('radios')}>Radios Cristianas</span></li>
                    <li><span className="link-nav-menu" onClick={() => openAudioPlayer('bible-stories')}>Historias de la Bíblia</span></li>
                </ul>
            </nav>
        </header>
    );
}